import { WebSocketMessageTypeOutgoing } from "../../../Enums/WebSocketMessageTypeOutgoing";

export class WsRequestActiveNotifications{
    public Type!: WebSocketMessageTypeOutgoing

    constructor(){
        this.Type = WebSocketMessageTypeOutgoing.WsRequestActiveNotifications;
    }
}